import React from 'react';
import { Stack, Typography } from '@mui/material';
import { variants } from '../variants/variants';
import { empty } from '../features/Gift/assets/index';

const NotFound = ({ width = '70%', height, message, src = empty, fontSize }) => {
  return (
    <Stack display={'flex'} alignItems={'center'} sx={{ p: 2 }} justifyContent={'center'} height={height}>
      <img style={{ width: width }} src={src} alt="pending" />
      <Typography sx={{ fontSize: fontSize || variants.TINY, p: 1, color: 'grey' }}>{message}</Typography>
    </Stack>
  );
};

export default NotFound;
